// frontend/src/utils/shopifyDoor.js
//
// The standalone app's door (`/shopify/install/?shop=…` on the API origin)
// is built by the backend (core.shopify_links.sign_in_url) and reaches the
// SPA as `shopify_sign_in_url` — on the anonymous /auth/whoami/ probe and on
// the selected store. The SPA only ever appends `next`: the same-site path
// the sign-in should land on, which the door validates before it runs.

/** `doorUrl` with `next=<path>` appended, preserving the query it carries. */
export function doorWithNext(doorUrl, nextPath) {
  const joiner = doorUrl.includes('?') ? '&' : '?';
  return `${doorUrl}${joiner}next=${encodeURIComponent(nextPath)}`;
}
